import React, {useEffect} from 'react'
import Header from 'components/Headers/Header'
import {useForm} from 'react-hook-form';
import { useDispatch } from 'react-redux';
import {
    Card,
    CardHeader,
    Container,
    Row,
    Button,
    Form,
    Input,
    Col,
    FormGroup
} from "reactstrap";
import { manualDexterity, manualDexterityReset, fetchManualDexterity } from 'redux/ManualDexterity/ManualDexterityActions';
import { connect } from 'react-redux';
import Swal from 'sweetalert2'
import Plans from './Plans';
const ManualDexterity = (props) => {

    const { register, getValues, unregister,watch, handleSubmit,setValue, formState: { errors } } = useForm();
    const dispatch = useDispatch();
    
    useEffect(() => {
        register("inputManualDexterity");
        dispatch(fetchManualDexterity({handle: props.userDetails.handle}))
        
        const statement_val = typeof props.fetchManualDexterity.manualdexterity.statement !== "undefined" ? props.fetchManualDexterity.manualdexterity.statement : "";
        setValue("inputManualDexterity", statement_val)
            

    }, [props.fetchManualDexterity.manualdexterity.statement,dispatch]);

    const onSubmit = (data) => {

        const userData = {
            handle: data.email,
            statement: data.inputManualDexterity
        }

        dispatch(manualDexterity(userData));
        
    }

    if(props.manualDexterity.loading){
        Swal.fire({
          allowOutsideClick : false,
          didOpen: () => {
            Swal.showLoading()
            
          }
        });
    
      }
      else{
      
        
        if(props.manualDexterity.manualdexterity.length && typeof props.manualDexterity.error === "undefined"){
          Swal.fire({
              title: 'Success!',
              text: 'Manual dexterity successfully save!',
              icon : 'success',
              timer: 3000
              
            }
          )
    
          dispatch(manualDexterityReset());
          
        }
    
        else if(typeof props.manualDexterity.error !== "undefined"){
    
         
            Swal.fire({
              title:'Failed!',
              text:'Something went wrong, Please try again!',
              icon :'error',
              timer: 3000
              
            })
          
              
            dispatch(manualDexterityReset());       
          
        }
    
      }
      const countWords = (str) => {
        str = str.trim();
  
        // Return 0 if the string is empty
        if (str === "") {
          return 0;
        }
        
        // Split the string into an array of words using whitespace as the delimiter
        const words = str.split(/\s+/);
        
        // Return the number of words
        return words.length;
  
      }
    return (
        <>
            <Header></Header>
                <Container className="mt--7" fluid>
                <Row>
                    <div className="col">
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <Card className="shadow">
                                <CardHeader className="border-0">
                                    <div className='float-left'>
                                        <h5 className="h3 mb-0">Manual Dexterity</h5>
                                    </div>
                                    <div className='float-right'>
                                        <Button color="primary" disabled={props.adminUser.admin ? "true" : ""} type='submit'>Save</Button>
                                    </div>
                                </CardHeader>
                                <Row className="pl-4 pr-4">
                                    <Col lg='12'>
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                                htmlFor="inputAchievementIssuedDate"
                                            >
                                              Describe any activities requiring manual dexterity (e.g. activities requiring hand-eye coordination such as cross-stitching, sewing, art, crafts, playing musical instrument, auto repair, etc.) at which you are proficient. Be sure to enter your response as a narrative list; do not use bullet points.
                                            </label>
                                            
                                            <Input
                                                className="form-control-alternative"
                                                id="inputManualDexterity"
                                                name="inputManualDexterity"
                                                placeholder="Write a text here ..."
                                                rows="15"
                                                value={watch("inputManualDexterity")}
                                                onChange={e => setValue("inputManualDexterity", e.target.value)}
                                                type="textarea"
                                                maxLength="600"
                                            />
                                            <div className='text-sm'>Character count : {(typeof getValues("inputManualDexterity") == "undefined")  ? "0" : getValues("inputManualDexterity").length}/600 | Word Count : {countWords((typeof getValues("inputManualDexterity") == "undefined")  ? "0" : getValues("inputManualDexterity"))}</div>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Card>
                        </Form>
                    </div>
                </Row>
            </Container>
            <Plans></Plans>
        </>
    )
}

const mapStateToProps = state => {
    return {
        manualDexterity : state.manualDexterity,
        userDetails : state.loginAuth.userDetails,
        fetchManualDexterity : state.fetchManualDexterity,
        adminUser : state.adminUser
    }
}

export default connect(mapStateToProps)(ManualDexterity)